import URLConst from '../constants/URLConst';
import { fetchJSON, secureGET, withQuery } from '../utilities/FetchHelper';
import memoryCache from '../utilities/MemoryCache';

const CACHE_KEY = 'countries'
const SUBDIVISION_COUNTRIES = new Set(['US', 'AU', 'CA', 'GB', 'MX'])

class CountryService {

    getCountries = (data) => {
        const { queryParams, locationType, ...urlParams } = data
        const countryCode = queryParams?.countryCode
        const wantsSubdivisions = queryParams?.expand === 'subdivisions'

        if (wantsSubdivisions && countryCode) {
            if (locationType === 'airport' && !SUBDIVISION_COUNTRIES.has(countryCode)) {
                return this._getCountryStripSubdivisions(urlParams, countryCode)
            }
            return this._getCountryWithSubdivisions(urlParams, countryCode)
        }

        return this._getCountryList(urlParams)
    }

    async _getCountryList(urlParams) {
        const cached = memoryCache.get(CACHE_KEY)
        if (cached) {
            return cached
        }

        const url = this._buildUrl(urlParams)
        const response = await fetchJSON(url, secureGET())
        memoryCache.set(CACHE_KEY, response)
        return response
    }

    async _getCountryStripSubdivisions(urlParams, countryCode) {
        const cacheKey = `${CACHE_KEY}_${countryCode}`
        const cached = memoryCache.get(cacheKey)
        if (cached) {
            return { countries: [{ ...cached, subdivisions: [] }] }
        }

        const url = withQuery(this._buildUrl(urlParams), { countryCode, expand: 'subdivisions' })
        const response = await fetchJSON(url, secureGET())
        const match = (response.countries || [])[0]
        if (match) {
            memoryCache.set(cacheKey, match)
        }
        return { countries: [{ ...match, subdivisions: [] }] }
    }

    async _getCountryWithSubdivisions(urlParams, countryCode) {
        const cacheKey = `${CACHE_KEY}_${countryCode}`
        const cached = memoryCache.get(cacheKey)
        if (cached) {
            return { countries: [cached] }
        }

        const url = withQuery(this._buildUrl(urlParams), { countryCode, expand: 'subdivisions' })
        const response = await fetchJSON(url, secureGET())
        const match = (response.countries || [])[0]
        if (match) {
            memoryCache.set(cacheKey, match)
        }
        return response
    }

    _buildUrl(urlParams) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_COUNTRIES
        for (const key in urlParams) {
            url = url.replace('{' + key + '}', urlParams[key])
        }
        return url
    }
}

export default new CountryService()